import type { ListProps } from "./types";

export function ListRoot({ children }: ListProps) {
  return (
    <div className="flex flex-col gap-1 overflow-y-auto flex-1">{children}</div>
  );
}
